<template>
    <div
        v-show="!props.hide"
        class="mobile-general-form-array"
        :class="`uuid-${config.uuid}`"
    >
        <div class="mobile-general-form-array-header" v-show="!props.hideTitle">
            <div
                class="mobile-general-form-array-header-label"
                :class="{ required: props.min }"
            >
                {{ i18nLabel }}
            </div>
            <div class="mobile-general-form-array-header-hint hint">
                {{ i18n(props.hint) }}
            </div>
            <div
                v-if="!props.autoCreateOne && !formArray.length"
                class="mobile-general-form-array-button is-add"
                @click="onAddButtonClick"
            >
                &#x2795;
            </div>
        </div>
        <transition-group name="array-item-list" tag="div">
            <div
                v-for="(item, itemIndex) in formArray"
                :key="`mobile-general-form-array-item-key-${item.config.uuid}`"
                class="mobile-general-form-array-item"
            >
                <div class="mobile-general-form-array-item-component">
                    <component
                        ref="singleItem"
                        :is="constComponentMap[singleItem.component]"
                        :originConfig="item.config"
                        :parentOutputPath="outputPath+`.${itemIndex}`"
                    ></component>
                </div>
                <div class="mobile-general-form-array-item-operable" v-if="!selfDisabled && !globalModel.preview">
                    <template v-if="props.sortable">
                        <div
                            class="mobile-general-form-array-button is-sort-up"
                            v-show="itemIndex > 0"
                            @click="onSortUpClick(itemIndex)"
                        >
                            &#x2B06;
                        </div>
                        <div
                            class="mobile-general-form-array-button is-sort-down"
                            v-show="itemIndex !== (formArray.length - 1)"
                            @click="onSortDownClick(itemIndex)"
                        >
                            &#x2B07;
                        </div>
                    </template>
                    <div
                        v-if="itemIndex < formArray.length - 1 || !props.autoCreateOne"
                        class="mobile-general-form-array-button is-delete"
                        @click="onDeleteButtonClick(itemIndex)"
                    >
                        <!-- &#x2796; -->
                        <svg
                            width="12"
                            height="4"
                            viewBox="0 0 12 4"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M11.6667 0.712891V3.04622H0V0.712891H11.6667Z" />
                        </svg>
                    </div>
                    <div
                        v-if="itemIndex === formArray.length - 1 && !selfDisabled && (!props.max || formArray.length < props.max)"
                        class="mobile-general-form-array-button is-add"
                        @click="onAddButtonClick"
                    >
                        <!-- &#x2795; -->
                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <!-- eslint-disable-next-line max-len -->
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.16536 4.83398V0.121094H4.83203V4.83398H0.164062V7.16732H4.83203V11.7878H7.16536V7.16732H11.8307V4.83398H7.16536Z" />
                        </svg>
                    </div>
                </div>
            </div>
        </transition-group>
    </div>
</template>
<script>
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import { SIMPLE_COMPONENT, COMPONENT_MAP } from '../register';
import MobileGeneralFormContainer from '../mobile-general-form-container';
import ComponentBase from '../component-base';
import { component } from './props';
export default {
    name: component,
    components: {
        ...SIMPLE_COMPONENT,
        MobileGeneralFormContainer,
    },
    extends: ComponentBase,
    created() {
        this.constComponentMap = COMPONENT_MAP;
    },
    data() {
        return {
            // 更改组件内组件uuid的生成方式为父组件id+数字
            childUid: 0,
            // 组件内部维护一份数据和uuid的对应关系
            formArray: [],
            // 验证错误信息
            errorMsg: '',
        };
    },
    computed: {
        formValue() {
            return this.formArray.map(item => item.value);
        },
        /**
         * 期望单个对象的数据结构为基本输入组件的数据结构
         * 数组组件的单个项目可能是几个基本组件的组合，这个时候请用tree组件包一层
         */
        singleItem() {
            return this.props.singleItem;
        },
        singleValue() {
            return typeof this.props.singleValue === 'undefined'
                ? null : this.props.singleValue;
        },
    },
    methods: {
        getNewUuid() {
            // 为配合可视化编辑器，复制器中的新组件id用父级id生成
            return `${this.uuid}_${this.childUid++}`;
        },
        onAddButtonClick() {
            this.formArray.push({
                config: {
                    ...this.singleItem,
                    uuid: this.getNewUuid(),
                },
                value: cloneDeep(this.singleValue),
            });
            this.updateSelfValue();
            this.$nextTick(() => {
                this.$emit('length-increase');
                this.$emit('length-change');
            });
        },
        onSortUpClick(index) {
            this.formArray[index] = this.formArray.splice(index - 1, 1, this.formArray[index])[0];
            this.updateSelfValue();
        },
        onSortDownClick(index) {
            this.formArray[index] = this.formArray.splice(index + 1, 1, this.formArray[index])[0];
            this.updateSelfValue();
        },
        onDeleteButtonClick(index) {
            this.formArray.splice(index, 1);
            this.updateSelfValue();
            this.$nextTick(() => {
                this.$emit('length-decrease');
                this.$emit('length-change');
            });
        },
        updateSelfValue() {
            this.setSelfFormDataValue(cloneDeep(this.formValue)) && this.$emit('change');
            // this.validateSelf();
        },
        // 判断是否满足自身条件
        validateSelf() {
            // 若为必填，则min设置不生效
            if (this.props.min && this.formArray.length < +this.props.min) {
                this.errorMsg = this.i18n(this.props.errMin, this.i18nLabel, this.props.min)
                    || `${this.i18nLabel}不得少于${this.props.min}项`;
                return false;
            }
            if (this.props.max && this.formArray.length > +this.props.max) {
                this.errorMsg = this.i18n(this.props.errMax, this.i18nLabel, this.props.max)
                    || `${this.i18nLabel}不得大于${this.props.max}项`;
                return false;
            }
            this.errorMsg = '';
            return true;
        },
        /**
         * 以下是组件公共方法的实现
         */
        dataChangeHandler() {
            const newValue = this.getSelfFormDataValue();
            if (!Array.isArray(newValue)) {
                // 需要初始化，默认值空数组
                this.formArray = [];
                if (this.props.autoCreateOne) {
                    this.onAddButtonClick();
                } else {
                    this.setSelfFormDataValue(this.formValue);
                }
                return;
            }

            if (!isEqual(this.formValue, newValue)) {
                for (const itemIndex in newValue) {
                    if (!this.formArray[itemIndex]) {
                        // 生成新配置属性
                        const newConfig = {
                            ...this.singleItem,
                            uuid: this.getNewUuid(),
                        };

                        this.formArray.push({
                            config: newConfig,
                            value: cloneDeep(newValue[itemIndex]),
                        });
                    } else {
                        this.formArray[itemIndex].value = cloneDeep(newValue[itemIndex]);
                    }
                }
                // 长度统一
                while (this.formArray.length > newValue.length) {
                    this.formArray.pop();
                }

                // 数据被动修改同样抛出change事件
                this.$emit('change');
                // this.validateSelf();
            }
        },
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            let res = this.validateSelf();
            if (res) {
                for (const index in this.$refs.singleItem) {
                    try {
                        res &= await this.$refs.singleItem[index].validate();
                    } catch (e) {
                        res = false;
                    }
                    if (!res) {
                        break;
                    }
                }
            } else {
                this.validateFailureHandler(this.errorMsg);
            }
            return res;
        },
        clearValidate() {
            if (this.$refs.singleItem) {
                this.$refs.singleItem.forEach(item => item.clearValidate());
            }
            this.errorMsg = '';
        },

    },

};
</script>
<style lang="less" scoped>
.mobile-general-form-array {
    .required:before {
        content: '*';
        color: #FF4A4A;
        margin-right: 4px;
    }

    .hint {
        margin-left: 1rem;
    }

    &-header {
        display: flex;
        align-items: baseline;
        padding-top: 0.5rem;
        &-hint {
            flex: 1;
        }
        &-label {
            margin: 0;
            font-size: 16px;
            height: 56px;
            font-weight: 400;
            line-height: 56px;
            text-indent: 16px;
            color: #777;
        }
    }

    &-item {
        display: flex;
        align-items: flex-start;
        margin-right: 10px;
        &-component {
            flex: 1;
        }
        &-operable {
            display: inherit;
        }
    }

    &-info {
        display: flex;
        &-error {
            flex: 1;
            color: #f56c6c;
            font-size: 0.8rem;
            line-height: 1;
            display: inline-flex;
            align-items: center;
            justify-content: flex-end;
            padding-right: 1rem;
        }
    }

    &-button {
        cursor: pointer;
        height: 56px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.is-add {
            padding: 0;
        }
        path {
            fill: #222;
        }
    }
}
.array-item-list-move {
  transition: transform 0.5s;
}
</style>
